<template>
  <div>
    <v-toolbar flat class="mb-4">
      <v-btn
        outlined
        :to="{
          name: 'FinancePersonDetail',
          params: { id: id },
          query:
            value && value.schoolClass
              ? { schoolClass: value.schoolClass.id }
              : { teachers: true },
        }"
        >zum Konto</v-btn
      ></v-toolbar
    >

    <v-card flat tile :loading="loading">
      <v-card-text> {{ itemsShown.length }} offenen Rechnungen </v-card-text>
    </v-card>

    <TableComponent
      :items="itemsShown"
      :loading="loading"
      @showDetails="showDetails"
    ></TableComponent>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper";
import TableComponent from "@/views/FinanceInvoices/TableComponent.vue";

export default defineComponent({
  name: "PersonFinance",
  components: {
    TableComponent,
  },
  props: {
    id: String,
    value: {},
  },
  computed: {
    canBalance() {
      return Math.abs(this.balance) > 0.25;
    },
    itemsShown() {
      return this.items
        .filter(
          (i) =>
            i.invoice &&
            !["archived", "entered"].includes(i.invoice.status.code)
        )
        .map((i) => i.invoice);
    },
    personId() {
      return Number.parseInt(this.id);
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  methods: {
    async fetchData() {
      if (this.personId) {
        this.loading = true;
        const items = await this.apiList({
          resource: "finance/invoicedetail",
          query: `person=${this.personId}`,
        });
        this.items = items;

        this.loading = false;
      }
    },
    showDetails(id) {
      const status = this.items.find((i) => i.invoice.id === id).invoice.status
        .code;
      const statusString =
        String(status).charAt(0).toUpperCase() + String(status).slice(1);
      this.$router.push({
        name: `FinanceInvoices${statusString}Detail`,
        params: { id: id },
      });
    },
  },
  watch: {
    async id() {
      await this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
